import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportReturnedPurchaseRequest } from './Purchase.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getReturnedPurchaseReport(
  params: QuestReportReturnedPurchaseRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/ReturnedPurchases`,
    params,
  )) as unknown;

  return result as BlobPart;
}
